export default __webpack_public_path__ + "static/media/drums.c0a2de00.png";